import { memo } from 'react';
import { useNavigation } from '@bonanza-social/navigation';
import { Box, PressableIcon } from '@bonanza-social/moonlight';
import { HEADER_HEIGHT } from './PrizeWallHeaderBase.content';
import { PrizeWallHeaderBaseProps } from './PrizeWallHeaderBase.types';

function PrizeWallHeaderBase({
  children,
  onBackPress,
  ...rest
}: PrizeWallHeaderBaseProps) {
  const navigation = useNavigation();

  return (
    <Box height={HEADER_HEIGHT} justifyContent="center" {...rest}>
      <PressableIcon
        position="absolute"
        left="space-400"
        name="arrowBack"
        alignItems="center"
        justifyContent="center"
        alignSelf="center"
        marginVertical="auto"
        backgroundColor="secondaryBackgroundHover"
        borderRadius="radius-full"
        width="space-1000"
        height="space-1000"
        iconWidth="space-500"
        iconHeight="space-500"
        color="iconSecondary"
        zIndex={1}
        onPress={onBackPress ?? navigation.goBack}
      />
      {children}
    </Box>
  );
}

export default memo(PrizeWallHeaderBase);
